import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { jwtDecode } from 'jwt-decode';

// --- MODIFICATION 1: IMPORT THE NEW PANEL AND REMOVE OLD IMPORTS ---
import BusinessProfilePureCSS from '../../profiles/BusinessProfilePureCSS';

import {
  Bell,
  DollarSign,
  Eye,
  HardHat,
  Heart,
  MessageSquare,
  Search,
  Settings,
  Star,
  TrendingUp,
  Users,
  Wrench,
  Link,
} from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "../../_newprofiles/components/ui/Avatar";
import { Badge } from "../../_newprofiles/components/ui/Badge";
import { Button } from "../../_newprofiles/components/ui/Button";
import { Card, CardContent, CardHeader, CardTitle } from "../../_newprofiles/components/ui/Card";
import styles from "./_BusinessDashboard.module.css";
import ModernNavbarPureCSS from "../../components/Navbar/ModernNavBarPureCSS";
import jobstyles from "../JobDashboard/NewHomeUserJobsDashboard.module.css";
import BusinessProfileNewV2 from '../../profiles/BusinessProfileNewV2';
import { X } from 'lucide-react';
import modalStyles from './SavedBusinesses.module.css';

const SavedBusinesses = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [businessUserId, setBusinessUserId] = useState(null);
  const [homeUserId, setHomeUserId] = useState(null);
  const [savedBusinessesData, setSavedBusinessesData] = useState([]);
  const [isLoadingSavedBusinesses, setIsLoadingSavedBusinesses] = useState(false);
  const [savedBusinessesError, setSavedBusinessesError] = useState(null);
  const [myuserType, setMyUserType] = useState(localStorage.getItem('userType'));
  const [loggedInBusinessId, setLoggedInBusinessId] = useState(localStorage.getItem('loggedInBusinessId'));

    // --- MODIFICATION 2: REPLACE MODAL STATE WITH PANEL STATE ---
  const [isBusinessProfileOpen, setIsBusinessProfileOpen] = useState(false);
  const [selectedBusinessId, setSelectedBusinessId] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUsername(decodedToken.UserName || 'User');
        const userType = decodedToken.UserType;
        setMyUserType(userType);
        if (userType === 'Business') {
          setBusinessUserId(decodedToken.nameid);
          setLoggedInBusinessId(localStorage.getItem('loggedInBusinessId'));
        } else {
          setHomeUserId(decodedToken.nameid);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        navigate('/login');
      }
    } else {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const fetchSavedBusinesses = async () => {
      setIsLoadingSavedBusinesses(true);
      setSavedBusinessesError(null);
      
      let url = '';
      if (myuserType === 'Business' && loggedInBusinessId) {
        url = `${API_BASE_URL}/api/BusinessProfile/getSavedBusinesses?userType=Business&userId=${loggedInBusinessId}`;
      } else if (myuserType === 'Home' && homeUserId) {
        url = `${API_BASE_URL}/api/BusinessProfile/getSavedBusinesses?userType=Home&userId=${homeUserId}`;
      }

      if (url) {
        try {
          const response = await axios.get(url);
          setSavedBusinessesData(response.data || []);
        } catch (err) {
          console.error("Error fetching saved businesses:", err);
          setSavedBusinessesError(err.message || "Failed to fetch saved businesses.");
          setSavedBusinessesData([]);
        } finally {
          setIsLoadingSavedBusinesses(false);
        }
      } else {
        setIsLoadingSavedBusinesses(false);
      }
    };

    if ((myuserType === 'Business' && loggedInBusinessId) || (myuserType === 'Home' && homeUserId)) {
      fetchSavedBusinesses();
    }
  }, [myuserType, loggedInBusinessId, homeUserId]);



  // --- MODIFICATION 3: ADD HANDLERS FOR THE SLIDING PANEL ---
  const openBusinessProfile = (businessId) => {
    setSelectedBusinessId(businessId);
    setIsBusinessProfileOpen(true);
  };

  const closeBusinessProfile = () => {
    setIsBusinessProfileOpen(false);
    setSelectedBusinessId(null);
  };



  const getFirstName = (name) => {
    if (!name || name.toLowerCase() === 'user') return 'User';
    return name.split(' ')[0];
  };

  const handleViewProfile = (businessId) => {
    const encodedBusinessId = btoa(businessId);
    setSelectedBusiness(encodedBusinessId);
  };

  const closeModal = () => {
    setSelectedBusiness(null);
  };

  return (

    <>

        <div className={jobstyles.jobDashboard_minHeightScreen + ' ' + jobstyles.jobDashboard_bgGradientBlueAmber}>
            
            <ModernNavbarPureCSS UserName={username} prefix={''} TabActiveId={'saved'} />

            <header className={jobstyles.jobDashboard_bgGradientHeader + ' ' + jobstyles.jobDashboard_header} style={{ position: 'sticky', top: 0, zIndex: 1020 }}>
                <div className={jobstyles.jobDashboard_container}>
                    <div className={jobstyles.bizjobDashboard_headerContent}>
                        <div className={jobstyles.jobDashboard_headerLeft}>
                            <div className={jobstyles.jobDashboard_headerLogo}>
                                <h1 className={jobstyles.jobDashboard_text2xl + ' ' + jobstyles.jobDashboard_fontBold}>Saved Businesses</h1>
                            </div>
                        </div>
                        <Link to="/business-portfolios/new" className={styles.createButton}>
                            Create Work Portfolio
                        </Link>
                    </div>
                </div>
            </header>



      <div className={`${styles.container} ${styles.mainContent}`}>
        <div className={styles.welcomeSection}>
          <p className={styles.welcomeSubtitle}>Here are the businesses you've saved</p>
        </div>

        <div className={styles.statsGrid}>
          {isLoadingSavedBusinesses && <p>Loading saved businesses...</p>}
          {!isLoadingSavedBusinesses && savedBusinessesError && <p className={styles.jobItem_errorText}>Error: {savedBusinessesError}</p>}
          {!isLoadingSavedBusinesses && !savedBusinessesError && savedBusinessesData.length === 0 && (
            <p>No saved businesses found.</p>
          )}
          {!isLoadingSavedBusinesses && !savedBusinessesError && savedBusinessesData.map((business) => (
            <Card key={business.businessId} className={styles.statCard}>
              <div style={{
                width: '100%',
                height: '150px',
                overflow: 'hidden',
                borderTopLeftRadius: '0.5rem',
                borderTopRightRadius: '0.5rem'
              }}>
                <img
                  src={business.profilePic || "/placeholder.svg"}
                  alt={business.businessName}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <CardContent className={styles.statCardContent} style={{ color: 'black' }}>
                <div className={styles.savedBusinessInfo}>
                  <h4 className={styles.savedBusinessName} style={{ color: 'black' }}>{business.businessName}</h4>
                  {business.description && (
                    <p className={styles.savedBusinessDescription}>{business.description}</p>
                  )}
                  <p className={styles.savedBusinessDescription}>{business.suburb}, {business.postCode}</p>
                  <div className={styles.ratingContainer}>
                    <Star className={styles.ratingStarIcon} />
                    <span className={styles.ratingValue}>{business.overallRating !== null ? business.overallRating.toFixed(1) : 'N/A'}</span>
                  </div>
                </div>


                                <Button variant="outline" size="sm" onClick={() => openBusinessProfile(business.businessId)}>
                                    View Profile
                                </Button>              
              
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

    </div>

        <BusinessProfilePureCSS
            isOpen={isBusinessProfileOpen}
            onClose={closeBusinessProfile}
            businessId={selectedBusinessId}
            useIDTYPE={"BID"}
        />
</>

  );
};

export default SavedBusinesses;
